export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';

const breadcrumbReducer = (state = [], action) => {
  switch (action.type) {
    case SET_BREADCRUMBS:
      return action.payload;
    default:
      return state;
  }
};

export default breadcrumbReducer;
